import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { 
  Paper, 
  Box, 
  Typography, 
  Button, 
  Divider
} from '@mui/material';
import { 
  WhatsApp as WhatsAppIcon, 
  QuestionAnswer as QuestionAnswerIcon,
  YouTube as YouTubeIcon,
  Instagram as InstagramIcon,
  Email as EmailIcon
} from '@mui/icons-material';
import { isLoggedIn } from '../api/account';

function CardPost (props) {
  const user = isLoggedIn();
  const { handleSubmit } = useForm();
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  
  const onSubmit = data => {
    setIsFormSubmitted(true);
  };

  const goBack = () => {
    setIsFormSubmitted(false);
  };

  if(isFormSubmitted) {
      return (
      <Paper
        elevation={2}
        sx={{
          borderRadius: 3,
          overflow: 'hidden',
          mb: 1.5,
          position: 'relative',
          background: 'linear-gradient(135deg, #4caf50 0%, #2e7d32 100%)',
          border: '1px solid rgba(255,255,255,0.1)',
          transition: 'all 0.2s ease'
        }}
      >
        <Box sx={{ p: 3, color: 'white' }}>
          <Typography variant="h5" component="h2" fontWeight="600" sx={{ mb: 1 }}>
            Thank You!
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, opacity: 0.9 }}>
            We have received your request. We will get back to you soon.
          </Typography>
          <Button
            variant="contained"
            disableElevation
            onClick={goBack}
            fullWidth
            sx={{
              mt: 1,
              py: 1.5,
              backgroundColor: 'rgba(255,255,255,0.2)',
              color: 'white',
              textTransform: 'none',
              fontWeight: 'bold',
              fontSize: '1rem',
              borderRadius: 8,
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.3)'
              }
            }}
          >
            Go Back
          </Button>
        </Box>
      </Paper>
    );
  } else {
      return (
      <Paper
        elevation={2}
        sx={{
          borderRadius: 3,
          overflow: 'hidden',
          mb: 1.5,
          position: 'relative',
          background: 'linear-gradient(135deg, #39777e 0%, #2c5e64 100%)',
          border: '1px solid rgba(255,255,255,0.1)',
          transition: 'all 0.2s ease',
          '&:hover': {
            boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
            transform: 'translateY(-2px)'
          }
        }}
      >
        <Box sx={{ p: 3, color: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Box
              sx={{
                backgroundColor: 'rgba(255,255,255,0.15)',
                borderRadius: '50%',
                p: 1.5,
                mr: 2.5,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <QuestionAnswerIcon sx={{ fontSize: 28 }} />
            </Box>
            <Box>
              <Typography variant="h5" component="h2" fontWeight="600" sx={{ mb: 0.5 }}>
                {props.title || "Ask mattool.in"}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                Have questions? We're here to help!
              </Typography>
            </Box>
          </Box>

          <Button
            variant="outlined"
            disableElevation
            component="a"
            href={`https://wa.me/918089783756?text= SEND MESSAGE TO START CONVERSATION [ ${user?.email || 'User'} ]`}
            target="_blank"
            rel="noreferrer"
            fullWidth
            startIcon={<WhatsAppIcon />}
            sx={{
              mt: 1,
              py: 1.5,
              backgroundColor: 'rgba(255,255,255,0.15)',
              borderColor: 'rgba(255,255,255,0.3)',
              color: 'white',
              textTransform: 'none',
              fontWeight: 'bold',
              fontSize: '1rem',
              borderRadius: 8,
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.25)',
                borderColor: 'rgba(255,255,255,0.5)'
              }
            }}
          >
            Click to chat with us
          </Button>

          <Divider sx={{ my: 2.5, borderColor: 'rgba(255,255,255,0.2)' }} />
          
          {/* Social Links */}
          <Box sx={{ mb: 1.5 }}>
            <Typography variant="body2" fontWeight="500" sx={{ mb: 1.5, opacity: 0.9 }}>
              Connect with us:
            </Typography>
            
            <Box sx={{ display: 'flex', justifyContent: 'space-around', gap: 2 }}>
              <Button 
                variant="outlined"
                component="a"
                href="mailto:contact.mattool.live@gmail.com"
                target="_blank"
                rel="noreferrer"
                startIcon={<EmailIcon />}
                sx={{ 
                  borderColor: 'rgba(255,255,255,0.3)',
                  color: 'white',
                  textTransform: 'none',
                  '&:hover': {
                    borderColor: 'rgba(255,255,255,0.6)',
                    backgroundColor: 'rgba(255,255,255,0.1)'
                  }
                }}
              >
                Email
              </Button>
              
              <Button 
                variant="outlined"
                component="a"
                href="https://www.youtube.com/channel/UCP7kTMHg1CiQY8_w_0B0TNQ"
                target="_blank"
                rel="noreferrer"
                startIcon={<YouTubeIcon />}
                sx={{ 
                  borderColor: 'rgba(255,255,255,0.3)',
                  color: 'white',
                  textTransform: 'none',
                  '&:hover': {
                    borderColor: 'rgba(255,255,255,0.6)',
                    backgroundColor: 'rgba(255,255,255,0.1)'
                  }
                }}
              >
                YouTube
              </Button>
              
              <Button 
                variant="outlined"
                component="a"
                href="https://www.instagram.com/mattool.in/?hl=en"
                target="_blank"
                rel="noreferrer"
                startIcon={<InstagramIcon />}
                sx={{ 
                  borderColor: 'rgba(255,255,255,0.3)',
                  color: 'white',
                  textTransform: 'none',
                  '&:hover': {
                    borderColor: 'rgba(255,255,255,0.6)',
                    backgroundColor: 'rgba(255,255,255,0.1)'
                  }
                }}
              >
                Instagram
              </Button>
            </Box>
          </Box>
          
          <Divider sx={{ my: 2, borderColor: 'rgba(255,255,255,0.2)' }} />
          
          {/* Quick Links */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Button 
              component="a"
              href="?page=tc"
              target="_blank"
              size="small"
              sx={{ 
                color: 'white',
                opacity: 0.8,
                textTransform: 'none',
                justifyContent: 'flex-start',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.1)',
                  opacity: 1
                }
              }}
            >
              Terms and Conditions
            </Button>
            
            <Button 
              component="a"
              href="https://www.youtube.com/watch?v=t3v0-aYc0EQ&list=PLtASNhZjSPhDEMvQ1xbpI1ZW30Qzr8zK9"
              target="_blank"
              rel="noreferrer"
              size="small"
              sx={{ 
                color: 'white',
                opacity: 0.8,
                textTransform: 'none',
                justifyContent: 'flex-start',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.1)',
                  opacity: 1
                }
              }}
            >
                Watch Help Videos
            </Button>
            
            <Button 
              component="a"
              href="https://www.youtube.com/shorts/J93MHSRM_kg"
              target="_blank"
              rel="noreferrer"
              size="small"
              sx={{ 
                color: 'white',
                opacity: 0.8,
                textTransform: 'none',
                justifyContent: 'flex-start',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.1)',
                  opacity: 1
                }
              }}
            >
              How to install mattool.in App?
            </Button>
          </Box>
        </Box>
      </Paper>
    );
  }
}

export default CardPost;
